import React, { useState, useEffect } from "react";

export default function NoInternet() {
  const [onlineStatus, setOnlineStatus] = useState(navigator.onLine);
  const [showNotification, setShowNotification] = useState(false);

  const handleOnline = () => {
    setShowNotification(true);
    setOnlineStatus(true);
    setTimeout(() => {
      setShowNotification(false);
    }, 2000);
  };

  const handleOffline = () => {
    setOnlineStatus(false);
  };

  useEffect(() => {
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return !onlineStatus ? (
    <div className="no-internet" style={{ position: "fixed" }}>
      <h3>Please check your internet connection.</h3>
    </div>
  ) : showNotification ? (
    <div className="no-internet" style={{ position: "fixed", backgroundColor: "var(--color-success)" }}>
      <h3>You're back online!</h3>
    </div>
  ) : null;
}
